import DepartmentTree from './container/index';

export default DepartmentTree;



// WEBPACK FOOTER //
// ./src/components/page/TeamTree/index.js